import React, { useState } from 'react';

const initialPlumbers = [
  { id: 1, name: 'Juan Pérez', contact: '555-1234', city: 'Ciudad de México', state: 'CDMX', availability: 'Available', focus: 'Residential', workingDays: 'Lunes-Viernes', workingTimes: '8:00-18:00' },
  { id: 2, name: 'María García', contact: '555-5678', city: 'Guadalajara', state: 'Jalisco', availability: 'Busy', focus: 'Commercial', workingDays: 'Lunes-Sábado', workingTimes: '9:00-17:00' },
  { id: 3, name: 'Carlos Hernández', contact: '555-8765', city: 'Monterrey', state: 'Nuevo León', availability: 'Available', focus: 'Residential', workingDays: 'Lunes-Viernes', workingTimes: '7:00-15:00' },
  { id: 4, name: 'Ana Martínez', contact: '555-4321', city: 'Puebla', state: 'Puebla', availability: 'Available', focus: 'Commercial', workingDays: 'Martes-Domingo', workingTimes: '10:00-20:00' },
  { id: 5, name: 'Luis López', contact: '555-2468', city: 'Tijuana', state: 'Baja California', availability: 'Busy', focus: 'Residential', workingDays: 'Lunes-Viernes', workingTimes: '8:00-16:00' },
  { id: 6, name: 'Sofía González', contact: '555-1357', city: 'León', state: 'Guanajuato', availability: 'Available', focus: 'Commercial', workingDays: 'Lunes-Sábado', workingTimes: '9:00-18:00' },
  { id: 7, name: 'Miguel Rodríguez', contact: '555-9753', city: 'Zapopan', state: 'Jalisco', availability: 'Available', focus: 'Residential', workingDays: 'Lunes-Viernes', workingTimes: '8:00-17:00' },
  { id: 8, name: 'Lucía Sánchez', contact: '555-8642', city: 'Mérida', state: 'Yucatán', availability: 'Busy', focus: 'Commercial', workingDays: 'Miércoles-Domingo', workingTimes: '10:00-19:00' },
  { id: 9, name: 'Jorge Ramírez', contact: '555-3579', city: 'Toluca', state: 'Estado de México', availability: 'Available', focus: 'Residential', workingDays: 'Lunes-Sábado', workingTimes: '7:00-14:00' },
  { id: 10, name: 'Fernanda Torres', contact: '555-4682', city: 'Querétaro', state: 'Querétaro', availability: 'Available', focus: 'Commercial', workingDays: 'Lunes-Viernes', workingTimes: '8:00-18:00' }
];

const Plumbers = () => {
  const [plumbers, setPlumbers] = useState(initialPlumbers);
  const [form, setForm] = useState({ name: '', contact: '', city: '', state: '', availability: '', focus: '', workingDays: '', workingTimes: '' });

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };

  const handleAdd = e => {
    e.preventDefault();
    if (!form.name || !form.contact || !form.city || !form.state || !form.availability || !form.focus || !form.workingDays || !form.workingTimes) return;
    setPlumbers(prev => [
      ...prev,
      {
        id: prev.length ? Math.max(...prev.map(p => p.id)) + 1 : 1,
        ...form
      }
    ]);
    setForm({ name: '', contact: '', city: '', state: '', availability: '', focus: '', workingDays: '', workingTimes: '' });
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 24 }}>
      <h2 style={{ textAlign: 'center', color: '#1976d2', marginBottom: 24 }}>Available Plumbers</h2>

      <form onSubmit={handleAdd} style={{ marginBottom: 32, display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
        <input name="name" value={form.name} onChange={handleChange} placeholder="Name" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 120 }} />
        <input name="contact" value={form.contact} onChange={handleChange} placeholder="Contact Number" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 120 }} />
        <input name="city" value={form.city} onChange={handleChange} placeholder="City" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 100 }} />
        <input name="state" value={form.state} onChange={handleChange} placeholder="State" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 80 }} />
        <input name="availability" value={form.availability} onChange={handleChange} placeholder="Availability" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 100 }} />
        <select name="focus" value={form.focus} onChange={handleChange} style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 120 }}>
          <option value="">Select Focus</option>
          <option value="Residential">Residential</option>
          <option value="Commercial">Commercial</option>
        </select>
        <input name="workingDays" value={form.workingDays} onChange={handleChange} placeholder="Working Days (e.g. Lunes-Viernes)" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 140 }} />
        <input name="workingTimes" value={form.workingTimes} onChange={handleChange} placeholder="Working Times (e.g. 8:00-18:00)" style={{ padding: 8, borderRadius: 4, border: '1px solid #ccc', minWidth: 140 }} />
        <button type="submit" style={{ padding: '8px 16px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontWeight: 600 }}>Add Plumber</button>
      </form>

      <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap', justifyContent: 'center' }}>
        {plumbers.map(plumber => (
          <div key={plumber.id} style={{
            background: '#f5f5f5',
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
            padding: 24,
            minWidth: 260,
            maxWidth: 300,
            border: '1px solid #e0e0e0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}>
            <h3 style={{ margin: '0 0 8px 0', color: '#1565c0' }}>{plumber.name}</h3>
            <div style={{ marginBottom: 4 }}><b>Contact:</b> {plumber.contact}</div>
            <div style={{ marginBottom: 4 }}><b>City:</b> {plumber.city}</div>
            <div style={{ marginBottom: 4 }}><b>State:</b> {plumber.state}</div>
            <div style={{ marginBottom: 4 }}><b>Availability:</b> {plumber.availability}</div>
            <div style={{ marginBottom: 4 }}><b>Focus:</b> {plumber.focus}</div>
            <div style={{ marginBottom: 4 }}><b>Working Days:</b> {plumber.workingDays}</div>
            <div style={{ marginBottom: 4 }}><b>Working Times:</b> {plumber.workingTimes}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plumbers;
